import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "name", "id", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    class: "forminput",
    type: _ctx.type,
    name: _ctx.name,
    id: _ctx.id,
    value: _ctx.value,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOnInput && _ctx.handleOnInput(...args)))
  }, null, 40, _hoisted_1))
}